/* Warwolf — comportamiento de las secciones a medida.
   Delegado y con alcance por seccion, para que convivan varias instancias. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var GRIP = {
    1: { grip: '72 %', dur: '3 series', dust: 'Ninguno', note: 'Una capa fina ya agarra. Es lo que recomendamos para press banca y remo.' },
    2: { grip: '94 %', dur: 'Sesion entera', dust: 'Minimo', note: 'El punto dulce. Dos capas aguantan una sesion completa de peso muerto sin repasar.' },
    3: { grip: '96 %', dur: 'Sesion entera', dust: 'Bajo', note: 'Ya no ganas casi agarre. Estas gastando producto de mas.' },
    4: { grip: '96 %', dur: 'Sesion entera', dust: 'Medio', note: 'Demasiado. La capa se apelmaza y empieza a caer polvo sobre la plataforma.' },
    5: { grip: '93 %', dur: 'Sesion entera', dust: 'Alto', note: 'Contraproducente: el exceso se desprende y arrastra el agarre hacia abajo.' }
  };

  /* Simulador de capas. Se inicializa por panel, no por seccion,
     para que puedan convivir varios en la misma pagina. */
  function initGrip(panel) {
    var range = panel.querySelector('[data-ww-range]');
    if (!range) return;
    var chalk = panel.querySelector('[data-ww-chalk]');
    var outGrip = panel.querySelector('[data-ww-out="grip"]');
    var outDur = panel.querySelector('[data-ww-out="dur"]');
    var outDust = panel.querySelector('[data-ww-out="dust"]');
    var outNote = panel.querySelector('[data-ww-out="note"]');

    function sync() {
      var v = parseInt(range.value, 10);
      var g = GRIP[v] || GRIP[2];
      if (chalk) chalk.style.opacity = String(0.16 + (v - 1) * 0.19);
      if (outGrip) outGrip.textContent = g.grip;
      if (outDur) outDur.textContent = g.dur;
      if (outDust) outDust.textContent = g.dust;
      if (outNote) outNote.textContent = g.note;
    }
    range.addEventListener('input', sync);
    sync();
  }

  /* Romper la ampolla: mantener pulsado. Al romperse baja a las formulas. */
  function initCrack(root) {
    var btn = root.querySelector('[data-ww-crack]');
    if (!btn) return;
    var hero = root.querySelector('[data-ww-hero]') || root;
    var fill = btn.querySelector('[data-ww-crack-fill]');
    var txt = btn.querySelector('[data-ww-crack-text]');
    var idle = btn.getAttribute('data-label-idle') || '';
    var done = btn.getAttribute('data-label-done') || '';
    var targetSel = btn.getAttribute('data-ww-crack-target');
    var raf, start = null, fired = false;

    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / 900, 1);
      if (fill) fill.style.width = (p * 100) + '%';
      if (p < 1) { raf = requestAnimationFrame(step); } else { fire(); }
    }

    function burst() {
      var r = btn.getBoundingClientRect();
      var x = r.left + r.width / 2;
      var y = r.top + r.height / 2;
      for (var i = 0; i < 26; i++) {
        var d = document.createElement('div');
        d.className = 'ww-dust';
        d.style.left = x + 'px';
        d.style.top = y + 'px';
        var s = 0.4 + Math.random() * 1.3;
        var ang = Math.random() * Math.PI * 2;
        var dist = 60 + Math.random() * 160;
        document.body.appendChild(d);
        d.animate(
          [
            { transform: 'translate(0,0) scale(' + s + ')', opacity: 0.9 },
            { transform: 'translate(' + Math.cos(ang) * dist + 'px,' + (Math.sin(ang) * dist - 40) + 'px) scale(0)', opacity: 0 }
          ],
          { duration: 700 + Math.random() * 600, easing: 'cubic-bezier(.15,.7,.3,1)' }
        ).onfinish = function () { d.remove(); };
      }
    }

    function goToTarget() {
      if (!targetSel) return;
      var el;
      try { el = document.querySelector(targetSel); } catch (err) { return; }
      if (!el) return;
      el.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' });
    }

    function fire() {
      if (fired) return;
      fired = true;
      btn.classList.add('is-done');
      if (txt && done) txt.textContent = done;
      hero.classList.add('is-jolt');
      if (!REDUCE && typeof btn.animate === 'function') burst();
      setTimeout(goToTarget, 520);
      setTimeout(function () {
        hero.classList.remove('is-jolt');
        btn.classList.remove('is-done');
        if (txt && idle) txt.textContent = idle;
        if (fill) fill.style.width = '0';
        fired = false;
        start = null;
      }, 2600);
    }

    function down(e) {
      e.preventDefault();
      cancelAnimationFrame(raf);
      start = null;
      raf = requestAnimationFrame(step);
    }
    function up() {
      cancelAnimationFrame(raf);
      if (!fired) { start = null; if (fill) fill.style.width = '0'; }
    }

    btn.addEventListener('mousedown', down);
    btn.addEventListener('touchstart', down, { passive: false });
    ['mouseup', 'mouseleave', 'touchend', 'touchcancel'].forEach(function (ev) {
      btn.addEventListener(ev, up);
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); fire(); }
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ww-section]').forEach(function (root) {
      if (root.dataset.wwReady === '1') return;
      root.dataset.wwReady = '1';
      root.querySelectorAll('[data-ww-grip-panel]').forEach(initGrip);
      initCrack(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // El personalizador de Shopify recarga secciones sueltas.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
